import { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";

const faqs = [
  { q: "可乐漫画上的内容可以免费看吗？", a: "可以。可乐漫画的基础漫画推荐与追更指南全部免费开放，让你随时都能配上一杯快乐水，随时开启快乐追更。" },
  { q: "追更榜单多久更新一次？", a: "榜单每周更新，编辑团队会根据人气、口碑和更新热度精选热门漫画，方便你快速找到值得追的快乐水组合。" },
  { q: "肥宅快乐套餐是什么？", a: "这是可乐漫画推出的追更搭配灵感，把漫画与快乐水、零食组合成专属套餐，让你在放松摸鱼时一次看个够。" },
  { q: "快乐水组合具体指什么？", a: "快乐水组合是指把快乐水（如可乐）和漫画追更、零食搭配在一起的放松方式，让看漫画这件事更有滋味、更解压。" },
  { q: "追更配零食怎么选？", a: "热血漫配经典原味和薯片很爽口，治愈日常漫配气泡款和坚果更舒服，悬疑烧脑时用坚果保持专注。量力而行，快乐第一。" },
  { q: "我在手机上也能正常浏览吗？", a: "当然可以。可乐漫画针对电脑、平板和手机都做了适配，随时随地都能打开快乐水追更之旅。" },
  { q: "你们会提供付费会员服务吗？", a: "目前可乐漫画的所有内容均免费开放，暂不提供付费会员。未来若有新增功能，会第一时间在站内与大家同步。" },
  { q: "如何联系可乐漫画团队？", a: "你可以通过页面顶部的联系我们入口或页脚的链接找到我们，欢迎分享你的追更心得与快乐水搭配创意。" },
];

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <Layout>
      <title>常见问题 - 关于快乐追更的那些事 | 可乐漫画</title>
      <meta name="description" content="可乐漫画常见问题解答：免费阅读、追更榜单更新频率、肥宅快乐套餐、快乐水组合、追更配零食等。帮你更快掌握配可乐看漫画的快乐。" />
      <meta name="keywords" content="可乐漫画,常见问题,快乐水组合,肥宅快乐套餐,追更配零食" />
      <link rel="canonical" href="https://snackview.github.io/faq" />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        })}
      </script>

      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-4xl px-4 py-10 md:px-6 md:py-14">
          <nav aria-label="面包屑" className="flex items-center gap-1.5 text-sm text-foreground-500">
            <Link to="/" className="hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
            <span className="text-foreground-800">常见问题</span>
          </nav>
          <h1 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">常见问题</h1>
          <p className="mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
            关于快乐水组合、肥宅快乐套餐与追更配零食的疑问，这里都有答案。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-10 md:px-6 md:py-14">
        <div className="space-y-3">
          {faqs.map((f, i) => (
            <div key={f.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <button
                type="button"
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
              >
                <span className="text-sm font-medium text-foreground-950 md:text-base">{f.q}</span>
                <i
                  className={`text-lg text-primary-600 transition-transform ${open === i ? "rotate-45" : ""}`}
                  style={{ width: 20, height: 20 }}
                >
                </i>
              </button>
              {open === i && <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-600">{f.a}</p>}
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-6 text-center">
          <h2 className="text-base font-medium text-foreground-950">还有疑问？</h2>
          <p className="mt-2 text-sm text-foreground-600">想了解更多，或想分享你的快乐水搭配创意，欢迎联系我们。</p>
          <Link
            to="/contact"
            className="mt-4 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            联系我们
            <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
          </Link>
        </div>
      </section>
    </Layout>
  );
}